import { initializeIcons } from "@fluentui/react/lib/Icons";
import { start, renderSplash } from "./actions/navigationWorker";
import { getParameterByName } from "./actions/loginWorker";
import { IsOverlayShown } from "./actions/helper";
import "../function-file/function-file";
import "@fluentui/react/dist/css/fabric.min.css";
import { getAppConfig } from "./appConfig";

initializeIcons();

function loadSplash(): void {
	renderSplash(false);
}

loadSplash();

Office.initialize = (): void => {};

Office.onReady().then(() => {
	start(getAppConfig());
	
	// Listen for email changes when add-in is pinned
	if (Office.context.mailbox && Office.context.mailbox.addHandlerAsync) {
		Office.context.mailbox.addHandlerAsync(
			Office.EventType.ItemChanged,
			() => {
				console.log("ItemChanged event fired - Email switched");
				console.log("New itemId:", Office.context.mailbox?.item?.itemId);
				console.log("New subject:", Office.context.mailbox?.item?.subject);
				
				// Don't refresh if there's an active operation (loading overlay is shown)
				if (IsOverlayShown()) {
					console.log("Operation in progress - skipping refresh");
					return;
				}
				
				// Clear filing-related session data for the new email
				sessionStorage.removeItem('note_date');
				sessionStorage.removeItem('subject');
				sessionStorage.removeItem('exclude_email_from_note');
				sessionStorage.removeItem('custom_note_body');
				
				// Give Office.js a moment to fully update the context
				setTimeout(() => {
					console.log("Reloading add-in UI for new email");
					start(getAppConfig());
				}, 100);
			}
		);
	}
});

// This runs for gmail plugin
const access_token = getParameterByName("useruniqueaccesstoken", null);
const scriptId = getParameterByName("scriptID", null);

if (access_token && scriptId) {
	start(getAppConfig());
}
